import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import LinearProgress from "@mui/material/LinearProgress";
import ListSubheader from "@mui/material/ListSubheader";
import { InputBaseComponentProps } from "@mui/material";
import { SxProps } from "@mui/material/styles";
import { useGetAllPositionsQuery } from "entitites/employees/api/employeesApi";
import { Toast } from "shared";
import { Status } from "entitites/employees/model/employee";

export const PositionSelect = ({
  sx,
  error,
  helperText,
  inputProps,
  value,
  onChange,
}: {
  sx?: SxProps;
  error?: boolean;
  helperText?: string;
  inputProps?: InputBaseComponentProps;
  value?: number | string;
  onChange?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
}) => {
  const {
    data: positions,
    isLoading,
    isError,
    isUninitialized,
    error: positionsError,
  } = useGetAllPositionsQuery();
  if (isLoading || isUninitialized) {
    return <LinearProgress sx={{ mt: -0.25, ml: -0.25 }} />;
  }

  if (isError) {
    return <Toast error={JSON.stringify(positionsError)} />;
  }

  const prepareToSelect = (positions: Status[]) => {
    const result: { [key: string]: Status[] } = {};

    positions.forEach((position) => {
      if (result[`${position.department}`]) {
        result[`${position.department}`].push(position);
      } else {
        result[`${position.department}`] = [position];
      }
    });

    return Object.keys(result).map((key) => ({
      group: key,
      data: result[key],
    }));
  };

  const prepareToSelectSecond = (positions: Status[]) => {
    const result: { [key: string]: Status[] } = {};

    positions.forEach((position) => {
      if (result[`${position.direction}`]) {
        result[`${position.direction}`].push(position);
      } else {
        result[`${position.direction}`] = [position];
      }
    });

    return Object.keys(result).map((key) => ({
      group: key,
      data: result[key],
    }));
  };

  console.log(prepareToSelect(positions));

  return (
    <TextField
      onChange={onChange}
      value={value}
      error={error}
      helperText={helperText}
      inputProps={inputProps}
      sx={{ minWidth: 370, ...sx }}
      fullWidth
      label="Поиск по позиции"
      select
      defaultValue=""
      size="small"
    >
      <MenuItem value="">
        <em>Выберите позицию</em>
      </MenuItem>

      {prepareToSelect(positions).map((position) => [
        <ListSubheader
          sx={{
            fontSize: 14,
            fontWeight: 600,
            bgcolor: "rgb(223 223 255)",
            color: "black",
          }}
        >
          {position.group}:
        </ListSubheader>,
        prepareToSelectSecond(position.data).map((pos) => [
          <ListSubheader
            sx={{ fontSize: 13, bgcolor: "rgb(231 233 241)", color: "black" }}
          >
            {" "}
            {pos.group}:
          </ListSubheader>,
          pos.data.map((pos) => (
            <MenuItem key={pos.id} value={pos.id}>
              {pos.name}
            </MenuItem>
          )),
        ]),
      ])}
    </TextField>
  );
};
